import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/lib/queryKeys'
import { listMilestoneRules } from '@/api/calendars'
import type { MilestoneRuleRead } from '@/types'

export function useMilestoneRules() {
  return useQuery<MilestoneRuleRead[]>({
    queryKey: queryKeys.milestoneRules.all,
    queryFn: listMilestoneRules,
    staleTime: 1000 * 60 * 10, // 10 minutes — rules rarely change
  })
}
